import React, { useState } from 'react';


const Accordion = ({ title, content, titleClass, contentClass, key }) => {
  const [isActive, setIsActive] = useState(false);

  var keyDown = (e) => {
    if(e.keyCode == 32 && e.target != document.body) {
      setIsActive(!isActive);
      e.preventDefault();
    }
  }

  return (
    <div className="accordion-item">
      <button
        id={`accordian-title-${key}`}
        tabIndex={0}
        aria-expanded={isActive}
        aria-controls={`accordian-content-${key}`}
        className={`accordion-title ${titleClass} ${isActive ? "accordion-open" : "accordion-closed"}`}
        onKeyDown={keyDown}
        onClick={() => setIsActive(!isActive)}
      >
        {title}
      </button>
      {isActive &&
        <div
          role="region"
          id={`accordian-content-${key}`}
          aria-labelledby={`accordian-title-${key}`}
          className={`accordion-content ${contentClass}`}
        >
          {content}
        </div>
      }
    </div>
  );
};

export default Accordion;